import { useContext, useState, lazy, Suspense } from 'react';
import ObjectHeroInformation from './ObjectHeroInformation';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';
import useMediaQuery from '../../CustomHooks/useMediaQuery';
const LoadAllImages = lazy(() => import('./LoadAllImages'));

const ImageSlider = () => {
  const [imageIndex, setImageIndex] = useState<number>(0);
  const { setMediaView, estate: data } = useContext(ObjectPageContext);
  const isMediumScreen = useMediaQuery('(min-width: 32rem)');

  function setMediaOptionView(id: string) {
    setMediaView(true);
    const newUrl = window.location.href + '#' + id;
    window.location.href = newUrl;
  }

  const nextImage = () => {
    setImageIndex(
      (imageIndex + 1) %
        (data?.images?.length > 10 ? 10 + 1 : Object.keys(data?.images)?.length)
    );
  };

  const prevImage = () => {
    setImageIndex(
      imageIndex === 0
        ? (data?.images?.length > 10
            ? 10 + 1
            : Object.keys(data?.images)?.length) - 1
        : imageIndex - 1
    );
  };
  return (
    <div className="flex flex-col items-center justify-center overflow-hidden w-full h-[250px] md:h-screen/2 lg:h-[76vh] max-h-3.5xl relative">
      <div
        style={{ transform: `translateX(-${imageIndex * 100}%)` }}
        className="flex w-full h-full transition ease-out duration-700"
      >
        {isMediumScreen && (
          <>
            {data?.images?.slice(0, 10).map((image, index) => {
              return (
                <div
                  onClick={() => setMediaOptionView('imageView')}
                  key={index}
                  className="cursor-pointer flex justify-center items-center flex-[0_0_100%]"
                >
                  {index === 0 ? (
                    <picture className="w-full h-full">
                      <img
                        width={1000}
                        height={680}
                        className="w-full h-full object-cover"
                        src={image?.path}
                        alt={data?.addressInfo?.streetAddress}
                        sizes="(max-width: 1440px) 100vw, 1440px"
                        loading="eager"
                      ></img>
                    </picture>
                  ) : (
                    <picture className="w-full h-full">
                      <img
                        width={1000}
                        height={680}
                        src={image?.path}
                        alt={data?.addressInfo?.streetAddress}
                        className="w-full h-full object-cover"
                        loading={`lazy`}
                      />
                    </picture>
                  )}
                </div>
              );
            })}
            {data?.images?.length > 10 && imageIndex > 8 && (
              <Suspense>
                <LoadAllImages />
              </Suspense>
            )}
          </>
        )}
        {!isMediumScreen && data?.images[0]?.path && (
          <div
            onClick={() => setMediaOptionView('imageView')}
            className="cursor-pointer flex justify-center items-center flex-[0_0_100%] min-h-[250px]"
          >
            <picture className="w-full h-full">
              <img
                loading="eager"
                width={700}
                height={400}
                className="w-full h-full object-cover"
                src={data?.images[0]?.mobilePath}
                alt={data?.addressInfo?.streetAddress}
              />
            </picture>
          </div>
        )}
      </div>
      {!isMediumScreen && (
        <img
          onClick={() => setMediaOptionView('imageView')}
          aria-label="Visa bildvy"
          src={'/Images/Icons/two-images.svg'}
          alt="ikon"
          loading="lazy"
          className="absolute top-4 right-4 ml-3 h-7 lg:h-10 w-auto"
          width={36}
          height={28}
        />
      )}
      <div
        onClick={() => setMediaOptionView('imageView')}
        className="absolute bottom-0 left-0 w-full h-2/3 mdplus:h-1/3 bg-linear-gradient cursor-pointer"
      ></div>

      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 px-2 lg:px-7 xxl:px-4 py-4 lg:pb-6 xxl:pb-8 w-full max-w-7xl flex justify-between items-end">
        <ObjectHeroInformation />
        {isMediumScreen && (
          <div className="gap-2 lg:gap-4 px-2 lg:px-0 pb-0 lg:pb-3 min-w-10 lg:min-w-[12rem] hidden lg:flex">
            <button
              className="flex items-center justify-center w-8 lg:w-11 h-8 lg:h-11 rounded-round border-white border-2"
              onClick={prevImage}
            >
              <img
                width="24"
                height="12"
                src={'/Images/Icons/Arrows/arrow-right-white.svg'}
                alt="Ikon föregående bild"
                className="w-4 lg:w-6 h-auto rotate-180"
                loading="lazy"
              />
            </button>
            <button
              className="flex items-center justify-center w-8 lg:w-11 h-8 lg:h-11 rounded-round border-white border-2"
              onClick={nextImage}
            >
              <img
                width="24"
                height="12"
                src={'/Images/Icons/Arrows/arrow-right-white.svg'}
                alt="Ikon nästa bild"
                className="w-4 lg:w-6 h-auto"
                loading="lazy"
              />
            </button>
            <button onClick={() => setMediaOptionView('imageView')}>
              <img
                width="52"
                height="40"
                src={'/Images/Icons/two-images.svg'}
                alt="Ikon bildvisning"
                className="ml-3 h-7 lg:h-10 w-auto"
                loading="lazy"
              />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
export default ImageSlider;
